module.exports = __webpack_public_path__ + "static/media/AU-Melbourne.e55bbd12.jpeg";